export const COLUMNSPROVE = [

    {
        Header:"Nombre",
        accessor:"nombre",
        width: 'auto',
    },
    {
        Header:"Email",
        accessor:"email",
        width: 'auto',
    },
    {
        Header:"Telefono",
        accessor:"telefono",
        width: 'auto',
    },
    {
        Header: "Cuit/Cuil",
        accessor:"cuit_cuil",
        width: 'auto',
    },
    {
        Header:"Direccion",
        accessor:"direccion",
        width: 'auto',
    },
    {
        Header: "",
        accessor:"cuenta-corriente",
        width: 'auto',
    },
    {
        Header: "",
        accessor:"editar",
        width: 'auto',
    },
    {
        Header: "",
        accessor:"eliminar",
        width: 'auto',
    }

]